(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["blog-sidebar-article-context"] && !Shopify.designMode) return;
  try {
    class BlogSidebarArticleContext extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.details = this.querySelector('[data-blog-sidebar-categories]');
      this.list = this.querySelector('[data-blog-sidebar-category-list]');
      this.status = this.querySelector('[data-blog-sidebar-category-status]');
      this.handleToggle = this.handleToggle.bind(this);
      this.details?.addEventListener('toggle', this.handleToggle);

      if (this.details?.open) this.loadCategories();
    }

    disconnectedCallback() {
      this.details?.removeEventListener('toggle', this.handleToggle);
    }

    handleToggle() {
      if (this.details?.open) this.loadCategories();
    }

    async loadCategories() {
      if (this.loaded || this.loading || !this.list || !this.dataset.storeDomain) return;

      this.loading = true;
      this.list.setAttribute('aria-busy', 'true');
      this.setStatus('Loading blog categories.');

      try {
        const categories = await this.fetchCategories();
        this.renderCategories(categories);
        this.loaded = true;
        this.setStatus(`${categories.length} blog categories loaded.`);
      } catch (error) {
        this.setStatus('Unable to load blog categories.');
      } finally {
        this.loading = false;
        this.list.setAttribute('aria-busy', 'false');
      }
    }

    async fetchCategories() {
      const categories = [];
      let after = null;
      let hasNextPage = true;

      while (hasNextPage) {
        const response = await fetch(`https://${this.dataset.storeDomain}/api/2026-07/graphql.json`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            query: `
              query BlogSidebarCategories($first: Int!, $after: String) {
                blogs(first: $first, after: $after, sortKey: TITLE) {
                  nodes {
                    handle
                    title
                  }
                  pageInfo {
                    endCursor
                    hasNextPage
                  }
                }
              }
            `,
            variables: { first: 250, after },
          }),
        });

        if (!response.ok) throw new Error(`Blog categories request failed with ${response.status}`);

        const payload = await response.json();
        if (payload.errors?.length) throw new Error(payload.errors[0].message);

        const connection = payload.data?.blogs;
        if (!connection) throw new Error('Blog categories were not returned');

        categories.push(...connection.nodes.filter((category) => category?.handle && category?.title));
        hasNextPage = Boolean(connection.pageInfo?.hasNextPage);
        after = connection.pageInfo?.endCursor || null;

        if (hasNextPage && !after) throw new Error('Blog categories pagination cursor was not returned');
      }

      return categories;
    }

    renderCategories(categories) {
      if (!categories.length || !this.list) return;

      const fragment = document.createDocumentFragment();
      const rootUrl = this.dataset.rootUrl?.endsWith('/') ? this.dataset.rootUrl : `${this.dataset.rootUrl || ''}/`;

      categories.forEach((category) => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `${rootUrl}blogs/${encodeURIComponent(category.handle)}`;
        link.textContent = category.title;

        if (category.handle === this.dataset.currentBlogHandle) {
          link.setAttribute('aria-current', 'page');
        }

        item.append(link);
        fragment.append(item);
      });

      this.list.replaceChildren(fragment);
    }

    setStatus(message) {
      if (this.status) this.status.textContent = message;
    }
  }

  if (!customElements.get('blog-sidebar-article-context')) {
    customElements.define('blog-sidebar-article-context', BlogSidebarArticleContext);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blog-sidebar"] && !Shopify.designMode) return;
  try {
    class BlogSidebarSearch extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.input = this.querySelector('[data-blog-sidebar-search-input]');
      this.button = this.querySelector('[data-blog-sidebar-search-button]');
      this.results = this.querySelector('[data-blog-sidebar-search-results]');
      this.status = this.querySelector('[data-blog-sidebar-search-status]');
      this.limit = Math.min(10, Math.max(1, Number.parseInt(this.dataset.resultsLimit || '10', 10) || 10));
      this.activeIndex = -1;
      this.requestId = 0;
      this.abortController = null;
      this.searchTimer = null;
      this.handleInput = this.onInput.bind(this);
      this.handleKeydown = this.onKeydown.bind(this);
      this.handleButtonClick = this.onButtonClick.bind(this);
      this.handleDocumentPointerdown = this.onDocumentPointerdown.bind(this);
      this.handleFocusout = this.onFocusout.bind(this);

      this.input?.addEventListener('input', this.handleInput);
      this.input?.addEventListener('keydown', this.handleKeydown);
      this.button?.addEventListener('click', this.handleButtonClick);
      this.addEventListener('focusout', this.handleFocusout);
      document.addEventListener('pointerdown', this.handleDocumentPointerdown);
    }

    disconnectedCallback() {
      window.clearTimeout(this.searchTimer);
      this.abortController?.abort();
      this.input?.removeEventListener('input', this.handleInput);
      this.input?.removeEventListener('keydown', this.handleKeydown);
      this.button?.removeEventListener('click', this.handleButtonClick);
      this.removeEventListener('focusout', this.handleFocusout);
      document.removeEventListener('pointerdown', this.handleDocumentPointerdown);
    }

    onInput() {
      window.clearTimeout(this.searchTimer);
      this.activeIndex = -1;
      const query = this.input?.value.trim() || '';

      if (query.length < 2) {
        this.abortController?.abort();
        this.clearResults();
        return;
      }

      this.searchTimer = window.setTimeout(() => this.search(query), 200);
    }

    onButtonClick() {
      const query = this.input?.value.trim() || '';
      if (query.length < 2) return;
      window.clearTimeout(this.searchTimer);
      this.search(query);
    }

    onKeydown(event) {
      const links = this.resultLinks();

      if (event.key === 'Escape') {
        this.closeResults();
        return;
      }

      if (!links.length || this.results?.hidden) return;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        this.setActiveResult((this.activeIndex + 1) % links.length);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        this.setActiveResult((this.activeIndex - 1 + links.length) % links.length);
      } else if (event.key === 'Enter' && this.activeIndex >= 0) {
        event.preventDefault();
        links[this.activeIndex]?.click();
      }
    }

    onDocumentPointerdown(event) {
      if (!this.contains(event.target)) this.closeResults();
    }

    onFocusout() {
      window.setTimeout(() => {
        if (!this.contains(document.activeElement)) this.closeResults();
      }, 0);
    }

    async search(query) {
      const requestId = ++this.requestId;
      this.abortController?.abort();
      this.abortController = new AbortController();
      this.setStatus('Searching articles.');

      const root = window.Shopify?.routes?.root || '/';
      const params = new URLSearchParams({
        q: query,
        'resources[type]': 'article',
        'resources[limit]': String(this.limit),
        'resources[limit_scope]': 'each',
      });

      try {
        const response = await fetch(`${root}search/suggest.json?${params}`, {
          headers: { Accept: 'application/json' },
          signal: this.abortController.signal,
        });

        if (!response.ok) throw new Error(`Predictive search failed with ${response.status}`);

        const payload = await response.json();
        if (requestId !== this.requestId || query !== this.input?.value.trim()) return;

        this.renderResults(payload.resources?.results?.articles || [], query);
      } catch (error) {
        if (error.name === 'AbortError' || requestId !== this.requestId) return;
        this.clearResults();
        this.setStatus('Blog search is temporarily unavailable.');
      }
    }

    renderResults(articles, query) {
      this.results?.replaceChildren();
      this.activeIndex = -1;

      if (!articles.length) {
        const item = document.createElement('li');
        item.className = 'blog-sidebar__search-message';
        item.textContent = 'No articles found.';
        this.results?.append(item);
        this.openResults();
        this.setStatus(`No articles found for ${query}.`);
        return;
      }

      const fragment = document.createDocumentFragment();

      articles.forEach((article, index) => {
        if (!article?.title || !article?.url) return;

        const item = document.createElement('li');
        item.className = 'blog-sidebar__search-result';
        item.setAttribute('role', 'none');

        const link = document.createElement('a');
        link.id = `${this.results.id}-option-${index}`;
        link.className = 'blog-sidebar__search-result-link';
        link.href = article.url;
        link.textContent = article.title;
        link.setAttribute('role', 'option');
        link.setAttribute('aria-selected', 'false');

        item.append(link);
        fragment.append(item);
      });

      this.results?.append(fragment);
      this.openResults();
      this.setStatus(`${this.resultLinks().length} article suggestions available for ${query}.`);
    }

    resultLinks() {
      return Array.from(this.results?.querySelectorAll('.blog-sidebar__search-result-link') || []);
    }

    setActiveResult(index) {
      const links = this.resultLinks();
      this.activeIndex = index;

      links.forEach((link, linkIndex) => {
        link.setAttribute('aria-selected', String(linkIndex === index));
      });

      const activeLink = links[index];
      if (!activeLink || !this.input) return;
      this.input.setAttribute('aria-activedescendant', activeLink.id);
      activeLink.scrollIntoView({ block: 'nearest' });
    }

    openResults() {
      if (!this.results || !this.input) return;
      this.results.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    }

    closeResults() {
      if (!this.results || !this.input) return;
      this.results.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      this.activeIndex = -1;
    }

    clearResults() {
      this.results?.replaceChildren();
      this.closeResults();
      this.setStatus('');
    }

    setStatus(message) {
      if (this.status) this.status.textContent = message;
    }
  }

  class BlogSidebarNewsletter extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.form = this.querySelector('[data-blog-sidebar-newsletter-form]');
      this.status = this.querySelector('[data-blog-sidebar-newsletter-status]');
      const email = this.form?.querySelector('input[type="email"]');
      const formId = this.closest('[data-newsletter-form-id]')?.dataset.newsletterFormId;
      if (!this.form || !email || !formId) return;

      this.initialized = true;
      this.form.id = formId;
      this.form.method = 'post';
      this.form.action = `${window.Shopify?.routes?.root || '/'}contact#${formId}`;
      this.form.acceptCharset = 'UTF-8';
      this.form.dataset.shopifyCaptcha = 'true';
      email.name = 'contact[email]';
      email.required = true;
      email.setAttribute('aria-required', 'true');

      for (const [name, value] of Object.entries({ form_type: 'customer', utf8: '✓' })) {
        let input = this.form.querySelector(`input[name="${name}"]`);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          this.form.append(input);
        }
        input.value = value;
      }

      window.Shopify?.captcha?.protect?.(this.form);

      const url = new URL(window.location.href);
      if (this.status && url.searchParams.get('customer_posted') === 'true' && url.hash === `#${formId}`) {
        this.setStatus(this.form.dataset.successMessage || 'Thanks for subscribing!', 'success');
        this.status.id = `${formId}-status`;
        this.status.tabIndex = -1;
        email.setAttribute('aria-describedby', this.status.id);
        this.status.focus();
      }
    }

    setStatus(message, status = '') {
      if (!this.status) return;
      this.status.textContent = message;
      if (status) {
        this.status.dataset.status = status;
      } else {
        delete this.status.dataset.status;
      }
    }
  }

  if (!customElements.get('blog-sidebar-search')) {
    customElements.define('blog-sidebar-search', BlogSidebarSearch);
  }

  if (!customElements.get('blog-sidebar-newsletter')) {
    customElements.define('blog-sidebar-newsletter', BlogSidebarNewsletter);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-actions"] && !Shopify.designMode) return;
  try {
    const ACCOUNT_DIALOG_GAP = 8;
  const ACCOUNT_DIALOG_VIEWPORT_INSET = 8;

  const positionAccountDialog = (accountEl) => {
    if (!(accountEl instanceof HTMLElement)) return;

    const dialog = accountEl.shadowRoot?.querySelector('dialog.dialog');
    const trigger = accountEl.closest('.account-button') ?? accountEl;

    if (!(dialog instanceof HTMLDialogElement) || !dialog.open) return;

    const icon = accountEl.shadowRoot?.querySelector('[part="signed-out-avatar"], [part="signed-in-avatar"]')
      ?? trigger;
    const iconRect = icon.getBoundingClientRect();
    const dialogWidth = dialog.offsetWidth;
    const maxLeft = window.innerWidth - dialogWidth - ACCOUNT_DIALOG_VIEWPORT_INSET;
    const left = Math.min(
      Math.max(ACCOUNT_DIALOG_VIEWPORT_INSET, iconRect.left),
      Math.max(ACCOUNT_DIALOG_VIEWPORT_INSET, maxLeft)
    );

    accountEl.style.setProperty('--account-dialog-top', `${iconRect.bottom + ACCOUNT_DIALOG_GAP}px`);
    accountEl.style.setProperty('--account-dialog-left', `${left}px`);
  };

  const bindAccountDialogPosition = (accountEl) => {
    if (!(accountEl instanceof HTMLElement) || accountEl.dataset.dialogPositionBound === 'true') return;

    accountEl.dataset.dialogPositionBound = 'true';

    const update = () => {
      requestAnimationFrame(() => {
        positionAccountDialog(accountEl);
        requestAnimationFrame(() => positionAccountDialog(accountEl));
      });
    };

    accountEl.addEventListener('open', update);
    window.addEventListener('resize', update);
    window.addEventListener('scroll', update, true);
  };

  const initAccountDialogPosition = () => {
    const accounts = document.querySelectorAll('shopify-account');

    for (const accountEl of accounts) {
      bindAccountDialogPosition(accountEl);
    }
  };

  initAccountDialogPosition();
  document.addEventListener('shopify:section:load', initAccountDialogPosition);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-included-benefits"] && !Shopify.designMode) return;
  try {
    const paintSvgCurrentColor = (svg) => {
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.removeAttribute('width');
    svg.removeAttribute('height');

    const paintedNodes = svg.querySelectorAll('[fill], [stroke]');

    for (const node of paintedNodes) {
      const fill = node.getAttribute('fill');
      const stroke = node.getAttribute('stroke');

      if (fill && fill !== 'none') {
        node.setAttribute('fill', 'currentColor');
      }

      if (stroke && stroke !== 'none') {
        node.setAttribute('stroke', 'currentColor');
      }
    }

    if (!svg.getAttribute('fill')) {
      svg.setAttribute('fill', 'currentColor');
    }
  };

  const inlineBenefitIcons = async () => {
    const icons = document.querySelectorAll('[data-benefit-icon-src]');

    for (const icon of icons) {
      const src = icon.getAttribute('data-benefit-icon-src');

      if (!src) continue;

      try {
        const response = await fetch(src);
        const markup = await response.text();
        const parsed = new DOMParser().parseFromString(markup, 'image/svg+xml');
        const svg = parsed.querySelector('svg');

        if (!(svg instanceof SVGElement)) continue;

        paintSvgCurrentColor(svg);
        icon.replaceChildren(svg);
        icon.removeAttribute('data-benefit-icon-src');
      } catch {
        continue;
      }
    }
  };

  inlineBenefitIcons();

  class ProductBenefitInfo extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.triggers = Array.from(this.querySelectorAll('[data-benefit-trigger]'));
      this.tooltip = this.querySelector('.product-details__benefit-tooltip');
      this.closeButton = this.querySelector('[data-benefit-close]');
      this.hoverMediaQuery = window.matchMedia(
        '(hover: hover) and (pointer: fine) and (min-width: 750px)'
      );
      this.handlePointerEnter = () => this.show();
      this.handlePointerLeave = () => this.hide();
      this.handleClick = (event) => this.toggle(event);
      this.handleCloseClick = (event) => this.onCloseClick(event);
      this.handleKeydown = (event) => this.onKeydown(event);
      this.handlePointerDownOutside = (event) => this.onPointerDownOutside(event);
      this.handleHoverMediaChange = () => this.syncHoverListeners();

      this.syncHoverListeners();
      this.hoverMediaQuery.addEventListener('change', this.handleHoverMediaChange);

      for (const trigger of this.triggers) {
        trigger.addEventListener('click', this.handleClick);
        trigger.addEventListener('keydown', this.handleKeydown);
      }

      this.closeButton?.addEventListener('click', this.handleCloseClick);
      document.addEventListener('pointerdown', this.handlePointerDownOutside);
    }

    disconnectedCallback() {
      this.teardownHoverListeners();
      this.hoverMediaQuery?.removeEventListener('change', this.handleHoverMediaChange);

      for (const trigger of this.triggers || []) {
        trigger.removeEventListener('click', this.handleClick);
        trigger.removeEventListener('keydown', this.handleKeydown);
      }

      this.closeButton?.removeEventListener('click', this.handleCloseClick);
      document.removeEventListener('pointerdown', this.handlePointerDownOutside);
    }

    get usesHover() {
      return Boolean(this.hoverMediaQuery?.matches);
    }

    syncHoverListeners() {
      this.teardownHoverListeners();

      // Desktop only: mobile/touch must open via tap/click, not sticky hover.
      if (!this.usesHover) return;

      this.addEventListener('pointerenter', this.handlePointerEnter);
      this.addEventListener('pointerleave', this.handlePointerLeave);
      this.hoverListenersBound = true;
    }

    teardownHoverListeners() {
      if (!this.hoverListenersBound) return;

      this.removeEventListener('pointerenter', this.handlePointerEnter);
      this.removeEventListener('pointerleave', this.handlePointerLeave);
      this.hoverListenersBound = false;
    }

    get isExpanded() {
      return this.triggers.some((trigger) => trigger.getAttribute('aria-expanded') === 'true');
    }

    show() {
      for (const trigger of this.triggers) {
        trigger.setAttribute('aria-expanded', 'true');
      }

      if (this.tooltip) {
        this.tooltip.hidden = false;
      }
    }

    hide() {
      for (const trigger of this.triggers) {
        trigger.setAttribute('aria-expanded', 'false');
      }

      if (this.tooltip) {
        this.tooltip.hidden = true;
      }
    }

    toggle(event) {
      event.preventDefault();
      event.stopPropagation();

      if (this.isExpanded) {
        this.hide();
        return;
      }

      this.show();
    }

    onCloseClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.hide();
      this.triggers[0]?.focus();
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.hide();
        this.triggers[0]?.focus();
        return;
      }

      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.toggle(event);
      }
    }

    onPointerDownOutside(event) {
      if (!this.contains(event.target)) {
        this.hide();
      }
    }
  }

  if (!customElements.get('product-benefit-info')) {
    customElements.define('product-benefit-info', ProductBenefitInfo);
  }
  } catch(e) { console.error(e); }
})();

})();
